import { render, staticRenderFns } from "./RecoverCredentialsProcessView.vue?vue&type=template&id=59a8ca34&"
import script from "./RecoverCredentialsProcessView.vue?vue&type=script&lang=js&"
export * from "./RecoverCredentialsProcessView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports